import { APIConfiguration, axiosBION } from 'api';
import { AxiosResponse } from 'axios';
import i18n from 'i18n';
import { GetNewsProps } from 'models/news.model';
import { FAQ } from 'models/faq.model';
import { Center, CenterIncludedFile, CenterIncludedService, CentersSearchResults } from 'models/centers.model';
import { DrupalTypes } from 'models/drupal.model';
import { BaseService } from './base.service';

class BNLService extends BaseService {
  static readonly AVAILABLE_LANGUAGES = ['fr', 'en', 'pt', 'de'];

  async searchCenters(
    lang: string,
    city?: string | number,
    speciality?: string | number,
    PMR?: boolean,
    parking?: boolean,
  ): Promise<
    {
      center: Center;
      file: CenterIncludedFile;
      services: CenterIncludedService[];
    }[]
  > {
    const language = BNLService.AVAILABLE_LANGUAGES.includes(lang.toLowerCase()) ? lang.toLowerCase() : 'fr';

    this.log(`searchCenters()`);

    return axiosBION
      .get(
        `/${language}${this.apiConfig.BNL.GET_CENTERS}${PMR ? '&filter[field_prelevement_handicape]=true' : ''}${parking ? '&filter[field_prelevement_parking]=true' : ''}${
          speciality && speciality !== -1 ? `&filter[field_prelevement_services.name]=${speciality}` : ''
        }${city && city !== -1 ? `&filter[field_prelevement_ville]=${city}` : ''}`,
      )
      .then((res: AxiosResponse<CentersSearchResults, any>) =>
        res.data.data.map((center) => ({
          center,
          file: res.data.included.filter(
            (included) => included.type === DrupalTypes.file && center.relationships.field_prelevement_photo.data !== null && center.relationships.field_prelevement_photo.data.id === included.id,
          )[0] as CenterIncludedFile,
          services: res.data.included.filter(
            (included) => included.type === DrupalTypes.service && center.relationships.field_prelevement_services.data.find((service) => service.id === included.id),
          ) as CenterIncludedService[],
        })),
      );
  }

  async getFAQ(lang: string, category: string): Promise<FAQ> {
    // Check language available
    const language = BNLService.AVAILABLE_LANGUAGES.includes(lang.toLowerCase()) ? lang.toLowerCase() : 'fr';

    const { data } = await axiosBION.get<any>(`/${language}${this.apiConfig.BNL.GET_FAQ}?filter[field_categorie_type]=${category}&include=field_type_de_sujet_filtres`);

    this.log(`getFAQ()`);

    return data.data.map((elem: any) => {
      return {
        id: elem.id,
        language: elem.attributes.langcode,
        category: elem.attributes.field_categorie_type,
        tags: elem.relationships.field_type_de_sujet_filtres.data.map((type: { id: string }) => data.included.find((include: { id: string }) => include.id === type.id).attributes.name),
        question: elem.attributes.title,
        answer: elem.attributes.body.value,
      };
    });
  }

  async getNews() {
    const locale = i18n.language.split('-').shift();
    const { data } = await axiosBION.get<GetNewsProps>(`/${locale}${this.apiConfig.BNL.GET_NEWS(4, '-created')}`);

    this.log(`getNews()`);

    return data;
  }
}

export default (apiConfig: APIConfiguration) => {
  return new BNLService(apiConfig);
};
